(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["theme-cart-drawer"]) return;
  try {
    

  $('button.continue-shopping').click(function() {
    $('.cart_drawer_overlay').removeClass('active');
  });

  $('button.close').click(function() {
    $('.cart_drawer_overlay').removeClass('active');
  });

  $('.cart_drawer_overlay').click(function(e) {
    if (e.target === this) {
      $('.cart_drawer_overlay').removeClass('active');
    }
  });


  } catch(e) { console.error(e); }
})();
})();
